import React from 'react';

export default function HistoryPanel({ history, setHistory }) {
  const handleClearHistory = () => {
    setHistory([]);
  };

  return (
    <div className="w-1/6 bg-gradient-to-b from-gray-50 to-gray-100 h-screen overflow-y-auto border-l border-gray-200 shadow-sm">
      <div className="p-3 flex justify-between items-center bg-white/50 border-b border-gray-200">
        <h2 className="text-sm font-semibold text-[#fdb814]">History</h2>
        <button
          className="p-1.5 rounded-lg text-[#fdb814] border-2 border-[#fdb814] hover:bg-gradient-to-r hover:from-[#fdb814] hover:to-[#e5a50f] hover:text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30"
          onClick={handleClearHistory}
          title="Clear History"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
      {history.length === 0 ? (
        <p className="px-2 text-xs text-gray-600">No requests yet.</p>
      ) : (
        <ul>
          {history.map((entry, index) => (
            <li key={index} className="px-3 py-2 border-b border-gray-200 hover:bg-white/50 transition-colors duration-200">
              <div className="flex justify-between">
                <span className="text-xs font-semibold text-[#fdb814]">{entry.method}</span>
                <span className="text-xs text-gray-500">{new Date(entry.timestamp).toLocaleTimeString()}</span>
              </div>
              <p className="text-xs text-gray-800 truncate">{entry.url}</p>
              <p className="text-xs text-gray-600">Status: {entry.status || 'N/A'}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}